export type Service = {
    number: string
    title: string
    items: string[]
}

export type Highlight = {
    value: string
    text: string
    label: string
    project: string
}

export type Tenet = {
    number: string
    title: string
    text: string
}

export type Tool = {
    name: string
    group: string
}

export const heroIntro = "Zaki Hatta, software engineer from Padang, Indonesia"

export const personalStatement = "I'm a software engineer who builds fast web platforms, real-time GIS systems and mobile apps. I care about the details people never notice, like the milliseconds between a warning and the person who needs it."

export const services: Service[] = [
    {
        number: "01.",
        title: "Frontend",
        items: ["Next.js and React", "TypeScript", "Tailwind CSS", "Responsive interfaces"]
    },
    {
        number: "02.",
        title: "Fullstack",
        items: ["Node.js services", "SQL and NoSQL databases", "Real-time WebSockets", "WordPress sites"]
    },
    {
        number: "03.",
        title: "GIS and mobile",
        items: ["WebGIS platforms", "Spatial data in ArcGIS Pro", "Routing algorithms", "React Native apps"]
    },
    {
        number: "04.",
        title: "Cloud",
        items: ["AWS", "Docker", "Deployment", "Performance tuning"]
    }
]

export const approachStatement = "Small, fast and dependable software, built close to the people who will use it."

export const tenets: Tenet[] = [
    {
        number: "i.",
        title: "Speed is a feature",
        text: "Moving alerts to WebSockets cut latency from 677 ms to 37 ms in my thesis project. I treat performance as part of the design, not a final polish."
    },
    {
        number: "ii.",
        title: "Plan for failure",
        text: "Shelters fill up, servers go down, signals drop. I build the fallback first, so the software still helps when things go wrong."
    },
    {
        number: "iii.",
        title: "Close to the client",
        text: "I work directly with the people I build for, from the first call to launch, so the result fits the business and not just the brief."
    }
]

export const highlights: Highlight[] = [
    {
        value: "18x",
        text: "Hazard alerts now reach phones in 37 ms instead of 677 ms, over persistent WebSocket connections.",
        label: "Faster alerts",
        project: "Padang Rescue"
    },
    {
        value: "0.4 ms",
        text: "When a shelter fills up, failover routing finds the next safe one in under half a millisecond.",
        label: "To reroute",
        project: "Padang Rescue"
    },
    {
        value: "40%",
        text: "A new Next.js platform lifted operational performance and doubled processing speed for international medical services.",
        label: "Better performance",
        project: "AssistCare Indonesia"
    },
    {
        value: "3.60",
        text: "Graduated in Informatics Engineering with a thesis on tsunami early warning and evacuation for Padang.",
        label: "GPA out of 4.00",
        project: "Padang State University"
    }
]

export const tools: Tool[] = [
    { name: "Next.js", group: "Frontend" },
    { name: "React", group: "Frontend" },
    { name: "TypeScript", group: "Language" },
    { name: "Tailwind CSS", group: "Styling" },
    { name: "Node.js", group: "Backend" },
    { name: "React Native", group: "Mobile" },
    { name: "Python", group: "Language" },
    { name: "SQL and NoSQL", group: "Data" },
    { name: "AWS", group: "Cloud" },
    { name: "Docker", group: "DevOps" },
    { name: "ArcGIS Pro", group: "GIS" },
    { name: "WordPress", group: "CMS" }
]
